import { useLang, IMAGES } from "@/lib/i18n";
import { Reveal, Eyebrow } from "./Reveal";

export const About = () => {
  const { t } = useLang();
  const a = t.about;
  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-2 lg:gap-20 lg:px-8">
        <Reveal>
          <Eyebrow>{a.eyebrow}</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-[44px] lg:leading-[1.1]">{a.title}</h2>
          <div className="mt-8 space-y-5 text-base leading-relaxed text-slate-300">
            {a.p.map((p) => <p key={p}>{p}</p>)}
          </div>
          <p data-testid="about-motto" className="mt-8 border-l-4 border-[#2F7BFF] pl-5 font-display text-xl font-bold text-white">{a.motto}</p>
        </Reveal>
        <Reveal delay={150} className="relative">
          <img src={IMAGES.yard} alt="Autovantis vehicle logistics" className="aspect-[4/3] w-full rounded-3xl object-cover shadow-[0_30px_60px_-30px_rgba(10,37,64,.5)]" />
          <div data-testid="about-stats" className="relative -mt-14 mx-4 grid grid-cols-3 divide-x divide-white/10 rounded-2xl border border-white/10 bg-[#0B1224]/90 p-6 text-white shadow-[0_20px_60px_-20px_rgba(47,123,255,.45)] backdrop-blur-xl sm:mx-10">
            {a.stats.map((s) => (
              <div key={s.l} className="px-2 text-center">
                <div className="font-display text-3xl font-extrabold text-[#2F7BFF] sm:text-4xl">{s.v}</div>
                <div className="mt-1 text-xs font-medium text-white/70 sm:text-sm">{s.l}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
